import { Pin } from "lucide-react";
import { cn } from "@/lib/utils";
import type { LivestreamPinnedComment } from "./livestreamPinnedComment";

export function LivestreamPinnedCommentBubble({
  pinnedComment,
  className,
}: {
  pinnedComment: LivestreamPinnedComment;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex w-full items-start gap-2 rounded-2xl border border-amber-400/30 bg-black/55 px-3 py-2 text-sm text-white shadow-[0_1px_8px_rgba(0,0,0,0.45)] backdrop-blur-sm",
        className,
      )}
      aria-label={`Pinned comment from ${pinnedComment.displayName}`}
    >
      <Pin className="mt-0.5 h-3.5 w-3.5 shrink-0 rotate-45 text-amber-200/90" aria-hidden />
      <div className="min-w-0">
        <span className="font-semibold">{pinnedComment.displayName}</span>
        <span className="opacity-90"> {pinnedComment.text}</span>
      </div>
    </div>
  );
}

export function LivestreamPinnedCommentOverlay({
  pinnedComment,
  className,
}: {
  pinnedComment: LivestreamPinnedComment | null;
  className?: string;
}) {
  if (!pinnedComment?.text) return null;

  return (
    <div
      className={cn(
        "pointer-events-none absolute bottom-[calc(max(0.75rem,env(safe-area-inset-bottom))+3.25rem)] left-3 right-16 z-40 sm:left-4 sm:bottom-[calc(max(0.75rem,env(safe-area-inset-bottom))+3.5rem)]",
        className,
      )}
      aria-live="polite"
    >
      <LivestreamPinnedCommentBubble pinnedComment={pinnedComment} />
    </div>
  );
}
